import { FunctionComponent, memo, useCallback, useRef, useState } from 'react';

import Tooltip from '../common/tooltip';
import DefineDocumentPreview from '../define-document-preview';
import {
	TDefineDocumentPreviewButtonProps,
	TDefineDocumentPreviewProps,
} from '../define-document-preview/define-document-preview.type';

const PreviewHistoryFile = ({
	className,
	label = '미리보기',
	link,
	readonly,
	filesNoAcceptDownloadAndPreview,
	...props
}: TDefineDocumentPreviewButtonProps) => {
	const [open, setOpen] = useState(false);

	const defineDocumentPreviewModal =
		useRef<FunctionComponent<TDefineDocumentPreviewProps>>();

	const onOpenModal = useCallback(() => {
		if (!defineDocumentPreviewModal.current) {
			defineDocumentPreviewModal.current = DefineDocumentPreview;
		}

		setOpen(true);
	}, [filesNoAcceptDownloadAndPreview, props]);

	const onCancel = useCallback(() => {
		setOpen(false);
	}, []);

	return (
		<>
			<Tooltip title="미리보기">
				<span
					className="cursor-pointer text-blue-500 underline"
					onClick={onOpenModal}
				>
					{props?.fileList?.[0]?.file?.name}
				</span>
			</Tooltip>
			{defineDocumentPreviewModal.current && (
				<defineDocumentPreviewModal.current {...{ ...props, open, onCancel }} />
			)}
		</>
	);
};

export default memo(PreviewHistoryFile);
